var $8b8ad8904d69cbb9$exports = {};
const $8b8ad8904d69cbb9$var$nav = document.querySelector('.nav');
const $8b8ad8904d69cbb9$var$headerSection = document.querySelector('.container');
const $8b8ad8904d69cbb9$var$navCheck = document.getElementById('nav-check');
const $8b8ad8904d69cbb9$var$navLinks = document.querySelectorAll('.nav-links a');
const $8b8ad8904d69cbb9$var$initialCoordinates = $8b8ad8904d69cbb9$var$headerSection.getBoundingClientRect();
window.addEventListener('scroll', function(e) {
    e.preventDefault();
    if (this.window.scrollY > $8b8ad8904d69cbb9$var$initialCoordinates.top) $8b8ad8904d69cbb9$var$nav.classList.add('sticky');
    else $8b8ad8904d69cbb9$var$nav.classList.remove('sticky');
});
document.addEventListener('DOMContentLoaded', function() {
    $8b8ad8904d69cbb9$var$navLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) targetElement.scrollIntoView({
                behavior: 'smooth'
            });
            setTimeout(function() {
                $8b8ad8904d69cbb9$var$navCheck.checked = false;
            }, 300);
        });
    });
});


//# sourceMappingURL=index.861dfae4.js.map
